import { render, staticRenderFns } from "./vip.vue?vue&type=template&id=b9890ff0&scoped=true&"
import script from "./vip.vue?vue&type=script&lang=js&"
export * from "./vip.vue?vue&type=script&lang=js&"
import style0 from "./vip.vue?vue&type=style&index=0&id=b9890ff0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9890ff0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9890ff0')) {
      api.createRecord('b9890ff0', component.options)
    } else {
      api.reload('b9890ff0', component.options)
    }
    module.hot.accept("./vip.vue?vue&type=template&id=b9890ff0&scoped=true&", function () {
      api.rerender('b9890ff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/event1/components/vip.vue"
export default component.exports